// extracted by mini-css-extract-plugin
export default {"upvote":"upvote_upvote__Ch3hK"};